'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var domReady = exports.domReady = function domReady(callback) {
  if (['interactive', 'complete'].indexOf(document.readyState) >= 0) {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/listeners/domReady.js
// module id = 165
// module chunks = 0